export const getCommentIconsByTriggerElement = (triggerElement: Element) => {
    const commentActionIcon =
        triggerElement.matches('.comment-action-icon')
            ? triggerElement
            : triggerElement.querySelector('.comment-action-icon');
    const positionCommentIcon =
        triggerElement.matches('.position-comment-icon')
            ? triggerElement
            : triggerElement.querySelector('.position-comment-icon');

    return {
        commentActionIcon,
        positionCommentIcon,
    };
};
